// src/context/CartContext.js
import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import axios from 'axios';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  // Generate or retrieve sessionID
  const getSessionID = () => {
    let sid = localStorage.getItem('sessionID');
    if (!sid) {
      sid = Math.random().toString(36).substring(2, 15);
      localStorage.setItem('sessionID', sid);
    }
    return sid;
  };

  const fetchCart = useCallback(async () => {
    try {
      const sessionID = getSessionID();
      const { data } = await axios.get('https://shophub-server.vercel.app/api/cart', {
        headers: { 'Session-ID': sessionID },
      });
      setCart(data.items || []);
    } catch (err) {
      console.error('Fetch cart error:', err);
    }
  }, []);

  useEffect(() => {
    fetchCart();
  }, [fetchCart]);

  const addToCart = async (product) => {
    try {
      const sessionID = getSessionID();
      await axios.post('https://shophub-server.vercel.app/api/cart/add',
        { productId: product._id, quantity: 1 },
        { headers: { 'Session-ID': sessionID } }
      );
      fetchCart();
    } catch (err) {
      console.error('Add to cart error:', err);
    }
  };

  const updateQuantity = async (productId, quantity) => {
    try {
      const sessionID = getSessionID();
      await axios.put('https://shophub-server.vercel.app/api/cart/update',
        { productId, quantity },
        { headers: { 'Session-ID': sessionID } }
      );
      fetchCart();
    } catch (err) {
      console.error('Update cart error:', err);
    }
  };

  const removeFromCart = async (productId) => {
    try {
      const sessionID = getSessionID();
      await axios.delete(`https://shophub-server.vercel.app/api/cart/remove/${productId}`, {
        headers: { 'Session-ID': sessionID },
      });
      fetchCart();
    } catch (err) {
      console.error('Remove from cart error:', err);
    }
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, updateQuantity, removeFromCart, fetchCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
